module.exports = __webpack_public_path__ + "static/media/instagram.bc5623c6.svg";